import { create } from 'zustand';
import { DrugItem } from 'src/api/types';
import { mountStoreDevtool } from 'simple-zustand-devtools';

interface State {
  setDrugListAnalytics: (analytics?: DrugItem['analytics']) => void;
  drugListAnalytics: DrugItem['analytics'] | null;
}

const useDrugListAnalyticsStore = create<State>()((set) => ({
  setDrugListAnalytics: async (analytics) => {
    set({ drugListAnalytics: analytics ?? null });
  },
  drugListAnalytics: null
}));

if (process.env.NEXT_PUBLIC_ENV === 'dev' && typeof window !== 'undefined') {
  mountStoreDevtool('DrugListAnalyticsStore', useDrugListAnalyticsStore);
}

export default useDrugListAnalyticsStore;
